import React from "react";
import Autocomplete from "react-google-autocomplete";

const GoogleLocation = () => {
  return (
    <div className="d-none">
      <Autocomplete
        apiKey={process.env.REACT_APP_GOOGLE_KEY}
        // onPlaceSelected={handlePlaceSelected}
        className="custom_input w-100 rounded-2 py-2 px-3 mt-2 "
        options={{
          types: ["(cities)"],
          componentRestrictions: { country: "in" },
        }}
        placeholder=""
      />
    </div>
  );
};

export default GoogleLocation;
